import { VehicleInfo } from "./components/VehicleSummaryCard";

  export const initialVehicleInfo: VehicleInfo = {
      vehicleManufacturerName: null,
      vehicleModelName: null,
      vehicleTypeName: null,
      vehicleImage: null,
      fuelType: null,
      transmission: null,
      maximumPowerHp: null,
      maximumPowerKw: null,
      cylinderCapacity: null,
      numberOfDoors: null,
      seats: null,
      jom: null,
      equipmentCount: null,
      tireDimensions: null,
      tireManufacturer: null,
      tireType: null,
      tireCount: null,
      dot: null,
      profileDepth: null,
      rof: null,
      fireExtinguisherName: null,
      fireExtinguisherExpirationDate: null,
      fireExtinguisherPrice: null,
      fireExtinguisherWeight: null,
      fireExtinguisherSerialNumber: null,
      ownerTypeId: null,
      ownerTypeName: null,
      ownerContactName: null,
      ownerPurchaseDate: null,
      ownerLeaseActivationDate: null,
      netPrice: null,
      specialTax: null,
      sellingPrice: null,
      netDiscount: null,
      vehicleInVatSystem: null,
      pictureUrls: [],
      documentTypesStatus: [],
      vinNumber: null,
      kmTraveled: null,
      registrationPlate: null
  };
  